/* Perfect Spoiler */

spoiler = {
	initPage: true,

	//Инициализировать все спойлеры на странице
	init: function() {
		var
			self = this;
		
		$('.js-spoiler').each(function() {
			var
				spoiler = $(this),
				open = spoiler.find('.js-open');

			if (!open.length) open = spoiler;
				
			open.on('click', self.toggle.bind(self));

			if (
				typeof spoiler.attr('data-open') == 'undefined' &&
				typeof spoiler.attr('data-preopen') == 'undefined'
			)
				open.click();
		});

		self.initPage = false;
	},

	//--------------------------------------------------------------------
	//Переключить спойлер (открыть или закрыть)
	toggle: function(event) {
		var
			button = $(event.currentTarget),
			spoiler = button.closest('.js-spoiler');

		if (spoiler.hasClass('process')) return;

		if (spoiler.hasClass('closed')) this.open(spoiler);
		else this.close(spoiler);
	},

	//--------------------------------------------------------------------
	//Открыть спойлер
	open: function(spoiler) {
		var
			content = spoiler.find('.js-content'),
			height = content.scrollTop() + content.outerHeight() + spoiler.outerHeight();
		
		this.closeAll(spoiler);

		if (this.initPage) {
			spoiler
				.css({height: height})
				.removeClass('closed');
		}

		else {
			spoiler.addClass('process').animate(
				{'height': height}, 200, function() {
					$(this).removeClass('process').removeClass('closed');
				}
			);
		}
	},

	//--------------------------------------------------------------------
	//Закрыть спойлер
	close: function(spoiler) {
		var
			header = spoiler.find('.js-header'),
			height = header.outerHeight();

		//Моментальное закрытие
		if (this.initPage) spoiler.addClass('closed').height(height);

		//Плавное закрытие
		else spoiler.addClass('process').animate(
			{'height': height}, 200, function() {
				$(this).removeClass('process').addClass('closed');
			});
	},

	//--------------------------------------------------------------------
	//Закрыть все спойлеры на странице
	closeAll: function(exclude) {
		var
			self = this;

		$('.js-spoiler:not([data-open]):not(.process)').each(function() {
			var
				spoiler = $(this);

			if (spoiler.get(0) != exclude.get(0))
				self.close(spoiler);
		})
	}

}



$(document).ready(function() {
	spoiler.init();
});